<form novalidate #currentForm="ngForm">
  <div class="content">
    <div class="step-header">
      <div class="group">
        <p *ngIf="step" >Name * <!--<vibe-tooltips [id]="step.id + '.' + 'name'"></vibe-tooltips>--></p>
        <input class="alias" autocomplete="off" 
               placeholder="Enter name for new group"
               name="name"
               maxlength="30"
               [(ngModel)]="name"
               #aliasInput="ngModel"
               #nameInput="ngModel"
               (ngModelChange)="nameUpdated()"
               [uniqueString]="groupNames"
               required/>
        <div class="error" *ngIf="aliasInput.invalid && (aliasInput.dirty || aliasInput.touched)">
          <mat-error *ngIf="aliasInput.errors.maxlength">Group name is too long.</mat-error>
          <mat-error *ngIf="aliasInput.errors.required">Group name is required.</mat-error>
          <mat-error *ngIf="aliasInput.errors.uniqueString">Group already defined.</mat-error>
        </div>
      </div>
    </div>
    <div class="separator"></div>
    <div class="dataSourceContainer">
      <div class="dataSource">
        <div class="dataSourceHeader">
          <div class="icon" (click)="step.subContent.toggleSubContent(true)">
            <mat-icon>add</mat-icon>
          </div>
          <div class="title">
            <div class="label">Users</div>
            <div class="description"></div>
          </div>
        </div>
        <div class="datasource_list">
          <div class="datasource"
               *ngFor="let member of step.output.userNames">
            <ng-container *ngIf="!member.hidden">
              <div class="icon" (click)="step.removeItem(step.output.userNames, member)"><mat-icon>clear</mat-icon></div>
              <img class="avatar" [src]="getGravatarUrl(member.email)" />
              <div class="member-info">
                <b>{{member.firstName}} {{member.lastName}}</b>
                <span>{{member.email}}</span>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
